// Runtime config (injected by docker-entrypoint.sh) takes precedence,
// then Vite build-time env, then same-origin fallback for production.
export const API_URL = window.__CONFIG__?.API_URL
  || import.meta.env.VITE_API_URL
  || '';
